export const OurVision = () => {
    return (
        <section className="family-showcase section" id="our-vision">
            <div className="container">
                <div className="family-showcase__wrapper">
                    <div className="family-showcase__image">
                        <img
                            src="/assets/family-hero.jpg"
                            alt="Multi-generational family using MAM together on a tablet, surrounded by magnolia blossoms"
                            loading="lazy"
                            className="family-image"
                        />
                    </div>
                    <div className="family-showcase__content">
                        <span className="section__badge">Our Vision</span>
                        <h2 className="section__title">Calmer, Clearer Decisions</h2>
                        <p className="family-showcase__description">
                            We created MAM to help families and parents make calmer, clearer decisions in an increasingly complex financial world.
                        </p>
                        <p className="family-showcase__description">
                            In an era where modern markets move at breakneck speeds and emotions often interfere with judgment, most AI tools attempt to solve the problem with faster answers—often without showing how those answers were formed.
                        </p>
                        <p className="family-showcase__description">
                            We chose a different path. We believe that the greatest risk to family wealth is not a lack of tools, but acting before risks are fully examined. Our platform exists to expand your perspective. By illuminating different angles and providing a broader view, we give you the comprehensive insight needed to think wisely before taking action.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};